import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  lateAttData:null,
  isFetching:false,
  isError:false
}  

export const lateAttSlice = createSlice({
  name: 'lateAtt',
  initialState,
  reducers: {
    fetchingLateAttStart: (state) => {
        state.isFetching = true
    },
    fetchingLateAttSuccess: (state,action) => {
        state.isFetching = false
        state.lateAttData = action.payload
    },
    fetchingLateAttErorr: (state) => {
        state.isFetching = false
        state.isError = true
    },
  },
})
   


// Action creators are generated for each case reducer function
export const {fetchingLateAttStart,fetchingLateAttSuccess,fetchingLateAttErorr} = lateAttSlice.actions

export default lateAttSlice.reducer